// 52爆料 首页静态数据（仅展示用，不接接口）
export interface FeedItem {
  id: string;
  tag: string;
  tagColor: string;
  title: string;
  excerpt: string;
  time: string;
  cover: string;
  up: number;
  reply: number;
  badge?: string;
  badgeStyle?: string;
  pinned?: boolean;
}

export interface SectionCard {
  id: string;
  name: string;
  en: string;
  desc: string;
  count: string;
  cover: string;
  accent: string;
}

export interface TopicItem {
  name: string;
  heat: number;
  trend: string;
}

export interface InsideItem {
  id: string;
  kicker: string;
  title: string;
  source: string;
  cover: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const heroCover =
  "https://readdy.ai/api/search-image?query=Vibrant%20editorial%20collage%20of%20anonymous%20speech%20bubbles%2C%20megaphone%2C%20newspaper%20clippings%20and%20pinned%20notes%20on%20a%20warm%20amber%20and%20coral%20background%2C%20playful%20community%20noticeboard%20aesthetic%2C%20high%20energy%2C%20lively%20typography%20textures%2C%20no%20real%20persons&width=1400&height=900&seq=hero-baoliao-2026&orientation=landscape";

export const sectionCards: SectionCard[] = [
  {
    id: "gua",
    name: "新鲜瓜田",
    en: "FRESH FIELD",
    desc: "刚出炉的热点与爆料都在这里，蹲着蹲着就长大了。",
    count: "今日 128 条更新",
    accent: "from-red-500/90 to-rose-600/90",
    cover:
      "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20colorful%20fresh%20watermelon%20slices%20and%20snack%20jars%20on%20a%20warm%20cream%20table%2C%20playful%20news%20gossip%20theme%2C%20bright%20vivid%20food%20photography%2C%20clean%20minimal%20background&width=800&height=533&seq=sec-gua-2026&orientation=landscape",
  },
  {
    id: "qing",
    name: "私信倾诉墙",
    en: "SECRET WALL",
    desc: "只想悄悄说的，匿名的我替你轻轻放在这面墙上。",
    count: "近 7 天 860 条心事",
    accent: "from-amber-500/90 to-orange-500/90",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20warm%20candles%20and%20handwritten%20letters%20in%20glass%20jars%20on%20a%20cozy%20desk%2C%20gentle%20heartfelt%20confession%20mood%2C%20golden%20hour%20lighting%2C%20warm%20neutral%20tones%2C%20editorial%20still%20life&width=800&height=533&seq=sec-qing-2026&orientation=landscape",
  },
  {
    id: "shuo",
    name: "我想说上墙",
    en: "SAY IT OUT",
    desc: "把没处讲的话贴上来，让大家一起接住你。",
    count: "日均 420 篇上墙",
    accent: "from-orange-500/90 to-red-500/90",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20sticky%20notes%20and%20polaroid%20photos%20pinned%20on%20a%20warm%20corkboard%20wall%2C%20community%20message%20wall%20theme%2C%20vibrant%20confetti%20accents%2C%20bright%20cheerful%20photography&width=800&height=533&seq=sec-shuo-2026&orientation=landscape",
  },
  {
    id: "nei",
    name: "内幕速递",
    en: "INSIDER EXPRESS",
    desc: "业内跟线抢先看，能不能吃上第一口就看手速。",
    count: "本周 96 条独家",
    accent: "from-rose-600/90 to-red-700/90",
    cover:
      "https://readdy.ai/api/search-image?query=Fast%20forward%20motion%20light%20streaks%20and%20newspaper%20cutouts%20on%20dark%20maroon%20red%20background%2C%20scoop%20news%20theme%2C%20dramatic%20lighting%2C%20mysterious%20insider%20mood&width=800&height=533&seq=sec-nei-2026&orientation=landscape",
  },
];

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    tag: "瓜田速报",
    tagColor: "bg-red-100 text-red-700",
    pinned: true,
    title: "某连锁食堂档口被曝后厨换牌不换料，学生已联名反映",
    excerpt: "有同学私下投稿说同一家档口反复更名但配方没变，味道一模一样，评论区一片吃瓜。",
    time: "12 分钟前",
    cover:
      "https://readdy.ai/api/search-image?query=Busy%20college%20canteen%20food%20counter%20with%20steaming%20dishes%20and%20students%20queuing%2C%20warm%20bright%20lights%2C%20documentary%20style%2C%20casual%20campus%20life%20photography&width=400&height=300&seq=feed-f1-2026&orientation=squarish",
    up: 3284,
    reply: 486,
    badge: "置顶热",
    badgeStyle: "bg-red-600 text-white",
  },
  {
    id: "f2",
    tag: "我想说",
    tagColor: "bg-orange-100 text-orange-700",
    title: "排队一小时就为那句 7 块钱的告白，值了",
    excerpt: "投稿人想跟校园广播站的某个声音说：谢谢你总在午后念到我的留言。",
    time: "28 分钟前",
    cover:
      "https://readdy.ai/api/search-image?query=Sunset%20campus%20radio%20broadcast%20tower%20with%20warm%20orange%20sky%20and%20gentle%20silhouette%2C%20nostalgic%20romantic%20mood%2C%20soft%20glow&width=400&height=300&seq=feed-f2-2026&orientation=squarish",
    up: 2516,
    reply: 168,
    badge: "心动了",
    badgeStyle: "bg-amber-500 text-white",
  },
  {
    id: "f3",
    tag: "内幕速递",
    tagColor: "bg-rose-100 text-rose-700",
    title: "传某奶茶联名系列下月上新，套餐价疑似内部流出",
    excerpt: "爆料说这波联名走怀旧路线，玻璃杯加周边，价格比上一轮略涨。",
    time: "45 分钟前",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20milk%20tea%20cups%20with%20retro%20cartoon%20characters%20on%20a%20warm%20pink%20pastel%20background%2C%20collaboration%20merchandise%20theme%2C%20product%20shot%20aesthetic&width=400&height=300&seq=feed-f3-2026&orientation=squarish",
    up: 1932,
    reply: 297,
  },
  {
    id: "f4",
    tag: "私信倾诉",
    tagColor: "bg-amber-100 text-amber-700",
    title: "考研二战的压力，只有凌晨的楼道灯光知道",
    excerpt: "投稿人匿了名，说怕辜负爸妈，又不敢让人知道自己偷偷哭了。",
    time: "1 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Dim%20warm%20corridor%20lamp%20light%20over%20study%20desk%20with%20books%20at%20midnight%2C%20lonely%20but%20hopeful%20mood%2C%20soft%20shadows%2C%20quiet%20atmosphere&width=400&height=300&seq=feed-f4-2026&orientation=squarish",
    up: 1678,
    reply: 532,
    badge: "抱抱",
    badgeStyle: "bg-orange-500 text-white",
  },
  {
    id: "f5",
    tag: "瓜田速报",
    tagColor: "bg-red-100 text-red-700",
    title: "某校园广播台被喊话别再当催铃，老师回应会改进",
    excerpt: "上墙后不到两小时就收到正式回复，大家都在夸这波执行力。",
    time: "2 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20vintage%20microphone%20and%20broadcast%20mixer%20with%20warm%20studio%20lights%2C%20school%20radio%20theme%2C%20documentary%20editorial%20photo&width=400&height=300&seq=feed-f5-2026&orientation=squarish",
    up: 1209,
    reply: 203,
    badge: "官方回应",
    badgeStyle: "bg-emerald-600 text-white",
  },
  {
    id: "f6",
    tag: "内幕速递",
    tagColor: "bg-rose-100 text-rose-700",
    title: "新赛季通行证皮肤线被扒，画风跟爆料对上了",
    excerpt: "内鬼流出的配色跟官方预告完全吻合，玩家群已经嗨翻。",
    time: "3 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20gaming%20skin%20showcase%20with%20futuristic%20warrior%20armor%20on%20dark%20background%2C%20esports%20season%20theme%2C%20vibrant%20red%20and%20gold%20glow&width=400&height=300&seq=feed-f6-2026&orientation=squarish",
    up: 988,
    reply: 421,
  },
];

export const topics: TopicItem[] = [
  { name: "# 食堂又涨价了", heat: 96, trend: "+128%" },
  { name: "# 谁家的年终奖", heat: 92, trend: "+96%" },
  { name: "# 新歌首播预告", heat: 88, trend: "+74%" },
  { name: "# 校招面经互助", heat: 81, trend: "+65%" },
  { name: "# 恋综剧本疑云", heat: 77, trend: "+58%" },
  { name: "# 奶茶联名上新", heat: 73, trend: "+52%" },
  { name: "# 演唱会抢票", heat: 69, trend: "+47%" },
  { name: "# 游戏新版本", heat: 64, trend: "+39%" },
  { name: "# 外卖优惠汇总", heat: 58, trend: "+33%" },
  { name: "# 考研上岸墙", heat: 52, trend: "+28%" },
];

export const insideItems: InsideItem[] = [
  {
    id: "i1",
    kicker: "业内跟线",
    title: "某连锁咖啡下季要出季节限定，薄荷口味或成主打",
    source: "匿名线人 A",
    cover:
      "https://readdy.ai/api/search-image?query=Iced%20mint%20green%20coffee%20drinks%20with%20cream%20on%20a%20clean%20cafe%20counter%2C%20seasonal%20limited%20edition%20theme%2C%20fresh%20spring%20tones%2C%20editorial%20drink%20photography&width=600&height=400&seq=inside-i1-2026&orientation=landscape",
  },
  {
    id: "i2",
    kicker: "跟帖爆料",
    title: "应届生吐槽笔试系统反复崩溃，官方连夜发补测通知",
    source: "评论区补充",
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20desk%20with%20laptop%20showing%20loading%20error%20screen%20and%20coffee%2C%20job%20application%20exam%20theme%2C%20dramatic%20warm%20desk%20lamp%20light&width=600&height=400&seq=inside-i2-2026&orientation=landscape",
  },
  {
    id: "i3",
    kicker: "旧闻新瓜",
    title: "那条被顶上热搜的老广播，如今评论区全是考古现场",
    source: "考古小队",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20cassette%20tape%20and%20retro%20radio%20on%20a%20warm%20vintage%20table%2C%20nostalgia%20internet%20trend%20theme%2C%20cozy%20amber%20lighting&width=600&height=400&seq=inside-i3-2026&orientation=landscape",
  },
];

export const faqItems: FaqItem[] = [
  {
    q: "投稿需要实名吗？",
    a: "完全不需要。52爆料默认匿名上墙，你的昵称、头像、联系方式都可以随便填或不填，我们不会向任何一方透露投稿来源，私信渠道也做了隐藏处理。",
  },
  {
    q: "投稿内容会先审核吗？",
    a: "会。内容会先经过审核再上墙，涉及造谣、人身攻击、泄露隐私、违规违法的稿件会被拦截或打码，这也是为了守住「想说但也要说好」的底线。",
  },
  {
    q: "发完想删掉怎么办？",
    a: "私信告诉小编留下你的上墙码，审核通过后即可下墙。只要不是被举报锁定的内容，我们都会在 24 小时内帮你处理干净。",
  },
  {
    q: "上墙后会被人认出是我吗？",
    a: "不会。我们不会公开 IP，也不会记录你投稿的设备信息。匿名就是对想说的人最大的保护，这也是大家敢在这里敞开的原因。",
  },
];

export const navLinks = [
  { name: "最新上墙", href: "#feed" },
  { name: "热门分区", href: "#sections" },
  { name: "今日在聊", href: "#topics" },
  { name: "内幕速递", href: "#inside" },
  { name: "投稿须知", href: "#faq" },
];

export const stats = [
  { value: "8.6w", label: "累计上墙" },
  { value: "1.2k", label: "日均更新" },
  { value: "99%", label: "匿名保护" },
  { value: "4h", label: "平均过审" },
];

export const tickerItems = [
  "爆：某食堂档口换牌不换料已上榜",
  "刚上墙：有人想跟广播站那个声音说谢谢",
  "内幕：某联名下月上新价格疑似流出",
  "倾诉：凌晨楼道那盏灯想替你擦眼泪",
  "回应：广播台老师已回复会改进",
  "想吃瓜，先来投稿，我来帮你发上墙",
];